import styled from "style/themed";

export const ToolsSubtitle = styled.p`
  margin-bottom: ${({ theme }) => theme.margin.medium};
`;
